module.exports = __webpack_public_path__ + "static/img/wzmacniacz4.16559af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/wzmacniacz4.png
// module id = PhTE
// module chunks = 1